export const LANGUAGE_STORAGE_KEY = 'plandag.language';

export type AppLanguage = 'en' | 'nb' | 'da' | 'sv';

export const APP_LANGUAGES: readonly { code: AppLanguage; label: string }[] = [
    { code: 'en', label: 'English' },
    { code: 'nb', label: 'Norsk' },
    { code: 'da', label: 'Dansk' },
    { code: 'sv', label: 'Svenska' },
];

function isAppLanguage(value: string | null): value is AppLanguage {
    return APP_LANGUAGES.some((lang) => lang.code === value);
}

export function readInitialLanguage(): AppLanguage {
    try {
        const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
        if (isAppLanguage(saved)) return saved;
    } catch {
        // Storage can be blocked. Fall through to the browser language.
    }

    const browser = navigator.language?.toLowerCase() ?? '';
    if (browser.startsWith('nb') || browser.startsWith('nn') || browser.startsWith('no')) return 'nb';
    if (browser.startsWith('da')) return 'da';
    if (browser.startsWith('sv')) return 'sv';
    return 'en';
}